import { useEffect } from 'react';
import { Heading, Paragraph, Table } from '@zillow/constellation-10';
import type { CreditReportType } from '@zg-rentals/ts-capps-client';
import { getCollections } from '@zg-rentals/applications-utils';
import type { EmitMetric } from '../../models/report-models';
import { ReportType } from '../../models/report-models';
import { countReportData } from '../../utils/report-utils';

export function CreditReportCollections({
  creditReport,
  emitMetric,
}: {
  creditReport: CreditReportType;
  emitMetric: EmitMetric;
}) {
  const collections = getCollections(creditReport);

  useEffect(() => {
    countReportData(ReportType.CreditReport, 'collections', collections?.length, emitMetric);
  }, []);

  return (
    <>
      <Heading level={3} textStyle="heading-xs" css={{ marginTop: 'md', marginBottom: 'xs' }}>
        Collections
      </Heading>
      {collections.length > 0 && (
        <Table.Responsive>
          <Table.Root aria-label="Collections table" appearance="horizontal" alignments={['left', 'right']} size="sm">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Creditor</Table.HeaderCell>
                <Table.HeaderCell>Amount</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {collections.map((inquiry) => (
                <Table.Row key={`${inquiry.name}-${inquiry.amount}`}>
                  <Table.HeaderCell>{inquiry.name}</Table.HeaderCell>
                  <Table.Cell>{inquiry.amount}</Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table.Root>
        </Table.Responsive>
      )}
      {!collections.length && <Paragraph textStyle="body-sm">None found</Paragraph>}
    </>
  );
}
